/**
 * Created by Administrator on 2017/7/2.
 */

import {SHOWBLOGLIST} from './actionTypes.js';

export default (state = {}, action) => {
    switch (action.type) {
        case SHOWBLOGLIST: {
            return {
                totalNumber:action.data.totalNumber,
                currentPage:action.data.currentPage,
                pageNumber:action.data.pageNumber,
                blogListTimeLine: action.data.blogList
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Component/BlogListTimeLine/reducer.js